import React from 'react';
import { Target, Clock, ChevronRight } from 'lucide-react';
import { Progress } from '../ui/progress';
import { useApp } from '../../context/AppContext';
import { cn } from '../../lib/utils';

const DailyGoalCard = ({ className }) => {
  const { userProgress } = useApp();
  const { dailyGoal, dailyProgress } = userProgress;
  const percentage = Math.min((dailyProgress / dailyGoal) * 100, 100);
  const isComplete = percentage >= 100;

  return (
    <div 
      className={cn(
        'card-elevated p-4',
        isComplete && 'border-success/30 bg-success-light/30',
        className
      )}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={cn(
            'w-8 h-8 rounded-full flex items-center justify-center',
            isComplete ? 'bg-success/10' : 'bg-primary/10'
          )}>
            <Target className={cn(
              'w-4 h-4',
              isComplete ? 'text-success' : 'text-primary'
            )} />
          </div>
          <div>
            <h3 className="font-semibold text-sm">Meta Diária</h3>
            <p className="text-xs text-muted-foreground">
              {isComplete ? 'Parabéns! Meta alcançada!' : 'Continue praticando'}
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-1 text-muted-foreground">
          <Clock className="w-4 h-4" />
          <span className="text-sm font-medium">{dailyProgress}/{dailyGoal} min</span>
        </div>
      </div>

      <Progress 
        value={percentage} 
        className={cn(
          'h-2',
          isComplete && '[&>div]:bg-success'
        )}
      />

      {!isComplete && (
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Faltam {dailyGoal - dailyProgress} minutos para completar sua meta
        </p>
      )}
    </div>
  );
};

export default DailyGoalCard;
